import { useState } from 'react'
import ClientProject from '../ClientProject/ClientProject'
import Heading from '../../Heading/Heading'
import Text from '../../Text/Text'

import './ClientCard.scss'

const ClientCard = (client) => {
  client = client.client

  const [projectData, setProjectData] = useState('')
  const [isExpanded, setIsExpanded] = useState('')

  const expandCard = (event, client) => {
    if (isExpanded) {
      setIsExpanded('')
      setProjectData('')
    } else {
      setIsExpanded(true)
      setProjectData(
        client.client.projects ? client.client.projects[0].sys.id : undefined
      )
    }
    event.stopPropagation()
  }

  const ExpandClose = (client) => {
    return (
      <button
        onClick={(e) => expandCard(e, client)}
        className={
          isExpanded
            ? 'client-card-button'
            : 'client-card-button client-card-expand-button'
        }
        aria-controls={client.client.title}
        aria-expanded={isExpanded ? 'true' : 'false'}>
        {isExpanded ? (
          'Close'
        ) : (
          <>
            Read more
            <span className="client-card-button-client-name">
              {` about the ${client.client.title} project`}
            </span>
          </>
        )}
      </button>
    )
  }

  const setProject = (id) => {
    setProjectData(id)
  }

  const ShowProject = (projectID) => {
    if (projectID.projectID === projectData) {
      return <ClientProject id={projectID.projectID} />
    } else return null
  }

  const Projects = (data) => {
    data = data.data
    if (isExpanded) {
      return (
        <div
          className="client-project-container"
          id={data.title.toLowerCase().replace(/ /g, '-')}>
          {[data.projects] &&
            [data.projects].map((clientsPojects, index) => (
              <div key={index}>
                <div className="client-project-select-container">
                  {clientsPojects &&
                    clientsPojects.map((projects, index) => (
                      <div key={index}>
                        <Heading
                          type="h4"
                          headingSize="h5"
                          className={
                            projectData === projects.sys.id
                              ? 'client-project-select-titles-highlighted'
                              : 'client-project-select-titles'
                          }
                          onClick={() => setProject(projects.sys.id)}>
                          Project {index + 1}
                        </Heading>
                      </div>
                    ))}
                </div>
                <div>
                  {clientsPojects &&
                    clientsPojects.map((projects, index) => (
                      <div key={index}>
                        <div className="projects">
                          <ShowProject projectID={projects.sys.id} />
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            ))}
        </div>
      )
    } else {
      return null
    }
  }

  return (
    <div
      className={isExpanded ? 'client-card client-card-shadow' : 'client-card'}>
      <div className="client-card-header">
        <div className="client-card-header-info">
          <img
            className="client-card-header-img"
            src={`https:${client.logo.fields.file.url}`}
            alt="Client logo"
          />
          <Heading headingSize="h3" className="client-card-header-h2">
            {client.title}
          </Heading>
        </div>
      </div>
      <Heading headingSize="h5" type="h3" className="client-card-overview">
        Client Overview
      </Heading>
      <Text className="client-card-overview-paragraph">{client.overview}</Text>

      <Projects data={client} />
      <div>
        <ExpandClose client={client} />
      </div>
    </div>
  )
}

export default ClientCard
